import { defineMessages } from 'react-intl';

export const youtubeNativeRecentTransmissionsMessages = defineMessages({
  offline: {
    id: 'logger.statusScreen.youtubeNative.offline',
    defaultMessage: 'OFFLINE',
  },
  noEmissionInProgress: {
    id: 'logger.statusScreen.youtubeNative.noEmissionInProgress',
    defaultMessage: 'Sin emisión en curso',
  },
  recentTransmissions: {
    id: 'logger.statusScreen.youtubeNative.recentTransmissions',
    defaultMessage: 'Transmisiones Recientes',
  },
  last24h: {
    id: 'logger.statusScreen.youtubeNative.last24h',
    defaultMessage: 'Últimas 24hs',
  },
  peakViewersTooltip: {
    id: 'logger.statusScreen.youtubeNative.peakViewersTooltip',
    defaultMessage: '{count} espectadores pico',
  },
  today: {
    id: 'logger.statusScreen.youtubeNative.today',
    defaultMessage: 'Hoy',
  },
  yesterday: {
    id: 'logger.statusScreen.youtubeNative.yesterday',
    defaultMessage: 'Ayer',
  },
  noRecentBroadcastsHelp: {
    id: 'logger.statusScreen.youtubeNative.noRecentBroadcastsHelp',
    defaultMessage: 'No hay transmisiones registradas en las últimas 24 horas.',
  },
});
